import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import NotFound from "pages/NotFound";
import Terms from "newSite/Terms";
import Privacy from "newSite/Privacy";
import FAQ from "newSite/FAQ";
import Landing from "newSite/Landing";
import GirlGroup from "newSite/GirlGroup";
import GirlGroupRulebook from "newSite/GirlGroupRulebook";
import BoyGroup from "newSite/BoyGroup";
import PatchUpdates from "newSite/PatchUpdates";
import Support from "newSite/Support";
import { isBoyGroupContestOpen } from "lib/boyGroupLaunch";

function BoyGroupRoute() {
  if (!isBoyGroupContestOpen()) return <Navigate to="/" replace />;
  return <BoyGroup />;
}

const ProjectRoutes = () => {
  let element = useRoutes([
    // App-promotion landing. The voting feed is no longer on the website.
    { path: "/", element: <Landing /> },
    { path: "/fyp", element: <Navigate to="/" replace /> },

    // Girl Group competition page.
    { path: "/girlgroup", element: <GirlGroup /> },
    { path: "/girlgroup/rulebook", element: <GirlGroupRulebook /> },

    // Boy Group competition page (OLYMPUS is RISING). Hidden until launch.
    { path: "/boygroup", element: <BoyGroupRoute /> },

    // Legal/info pages render standalone with their own dark LegalShell.
    { path: "/updates", element: <PatchUpdates /> },
    { path: "/faq", element: <FAQ /> },
    { path: "/support", element: <Support /> },
    { path: "/terms", element: <Terms /> },
    { path: "/privacy", element: <Privacy /> },

    // Website signup/login is disabled — auth lives in the native apps.
    { path: "/login", element: <Navigate to="/" replace /> },
    { path: "/register", element: <Navigate to="/" replace /> },
    { path: "/forgot-password", element: <Navigate to="/" replace /> },

    // Old competitions pages (pre-FYP site) are gone but still indexed by
    // Google; send them home instead of the 404 page.
    { path: "/competitions", element: <Navigate to="/" replace /> },
    { path: "/competitions/*", element: <Navigate to="/" replace /> },

    // Legacy URLs kept for backwards compatibility (must be before catch-all).
    { path: "/termsconditions", element: <Terms /> },
    { path: "/privacypolicy", element: <Privacy /> },
    { path: "/arianagrande", element: <Navigate to="/" replace /> },
    { path: "/newsite/*", element: <Navigate to="/" replace /> },

    { path: "*", element: <NotFound /> },
  ]);

  return element;
};

export default ProjectRoutes;
